import React from 'react';
import '../Css/Order.css';
import { Link, useLocation } from 'react-router-dom';
import Navbar from './Navbar';

function MapNav() {
  const location = useLocation();
  const role = sessionStorage.getItem('role');
  const showRouteOptimization = role !== 'dispatcher' && role !== 'packer';

  return (
    <div className="orderBody">
      <Navbar />
      {/* <div className="containerDd">
        <div className="HeaderD">
          <p className="Dp"><b>Map</b></p>
        </div>
      </div> */}
      <div className="buttonD">
        <button className={`buttonsD ${location.pathname === '/Map' ? 'highlighted' : ''}`}>
          <Link to="/Map">Map</Link>
        </button>
        {showRouteOptimization && (
          <button className={`buttonsD ${location.pathname === '/RouteOptimization' ? 'highlighted' : ''}`}>
            <Link to="/RouteOptimization">Route Optimization</Link>
          </button>
        )}
      </div>
    </div>
  );
}

export default MapNav;
